import { Component, OnInit, Inject, inject } from '@angular/core';
import { AttachmentListComponent } from '../../attachment-list/attachment-list.component';
// import { ContractManagerService } from "../../../service/contract-manager.service";
import { MatDialogRef,
         MAT_DIALOG_DATA } from '@angular/material/dialog';
// import { GlobalDataService } from '../../../global-data.service';
import { AttachmentsService } from '../../../service/files-and-attachments/attachments.service';

import { AgGridModule } from 'ag-grid-angular';

import { MatSidenavModule } from '@angular/material/sidenav';
import { MatDividerModule } from '@angular/material/divider';

@Component({
    selector: 'app-templates-list',
    templateUrl: './templates-list.component.html',
    styleUrls: ['./templates-list.component.css'],
    standalone: true,
    imports: [
      AgGridModule,
      MatSidenavModule,
      MatDividerModule
    ]
  })
export class TemplatesListComponent extends AttachmentListComponent implements OnInit {

  attachmentList: any[] = [];
  
  constructor(
    
    private dialogRef: MatDialogRef<TemplatesListComponent>,
    @Inject(MAT_DIALOG_DATA) data) {

      super();

      if (data && data.listTitle) {
        this.listTitle = data.listTitle;
      }

      if (data && data.attachmentType) {
            this.attachmentsFilter = data.attachmentType;
      }

  }

  async ngOnInit() {

    // this.attachmentsService.allAttachments$.subscribe(allAttachments => {
    //   // When the data arrives, assign it to your component's property
    //   this.attachmentList = allAttachments;
    // });

    // // BUGBUG ANGULAR 20 UPGRADE - I don't remember what this was for and I doubt we need it
    // // this.attachmentList = this.attachmentsService.filterAttachmentListForLetters(this.attachmentList);

    // if (this.attachmentsFilter) {
    //   this.attachmentList = this.attachmentList.filter( attachment => attachment.attachmentData.attachmentType === this.attachmentsFilter);
    //   this.columnsAttachmentList = [this.colAttachmentName];
    // }

    // const delay = ms => new Promise(res => setTimeout(res, ms));
    // await delay(500); // .5 second so sizeColumnsToFit() will work

    // this.gridApi.sizeColumnsToFit();

  }

  onCellClicked(event: any) {
      // this.messageEvent.emit(event.data.attachmentData);
      this.dialogRef.close(event.data);
  }  

}
